import React, { useState } from 'react';
import { Stack, InputGroup, InputRightElement, IconButton, Select } from '@chakra-ui/react';
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';
import ReusableDrawer from "../../../../components/Drawers/ReusableDrawer.js";
import headerImage from '../../../../assets/img/background.png';
import GradientButton from 'components/Buttons/GradientButton.js';
import ReusableInput from 'components/Inputs/ReusableInput.js';

const AddSizeEstimates = ({ isOpen, onClose, onAddSizeEstimate }) => {
  const [formData, setFormData] = useState({
    weight: 0,
    length: 0,
    width: 0,
    height: 0,
    sizeCategory: 'Small',
  });

  const [show, setShow] = useState(false);
  const handleClick = () => setShow(!show);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    // Create the object to submit, only including the necessary fields
    const formDataToSubmit = {
      weight: formData.weight,
      length: formData.length,
      width: formData.width,
      height: formData.height,
      size_category: formData.sizeCategory,
    };

    // Call the action to add the size estimate
    onAddSizeEstimate(formDataToSubmit);
    onClose();
  };

  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={onClose}
      headerImage={headerImage}
      headerContent={<h2>Add Size Estimate</h2>}
      bodyContent={
        <Stack spacing={4}>
          <ReusableInput
            label="Weight (kg)"
            name="weight"
            type="number"
            value={formData.weight}
            onChange={handleInputChange}
            placeholder="Enter weight"
          />
          <ReusableInput
            label="Length"
            name="length"
            type="number"
            value={formData.length}
            onChange={handleInputChange}
            placeholder="Enter length"
          />
          <ReusableInput
            label="Width"
            name="width"
            type="number"
            value={formData.width}
            onChange={handleInputChange}
            placeholder="Enter width"
          />
          <ReusableInput
            label="Height"
            name="height"
            type="number"
            value={formData.height}
            onChange={handleInputChange}
            placeholder="Enter height"
          />
          
          <ReusableInput
            label="Size Category"
            name="sizeCategory"
            type="select"
            value={formData.sizeCategory}
            onChange={handleInputChange}
            options={[
              { value: 'Small', label: 'Small' },
              { value: 'Medium', label: 'Medium' },
              { value: 'Large', label: 'Large' },
              { value: 'Extra Large', label: 'Extra Large' },
            ]}
          />
        </Stack>
      }
      footerContent={
        <Stack direction="row" spacing={4} justifyContent="flex-end">
          <GradientButton onClick={onClose} fontSize={"15px"} width={"100px"} height={"40px"}>Cancel</GradientButton>
          <GradientButton onClick={handleSubmit} fontSize={"15px"} width={"100px"} height={"40px"}>Save</GradientButton>
        </Stack>
      }
    />
  );
};

export default AddSizeEstimates;
